/**
 * Parse a comma-separated string into a trimmed list, dropping empty entries.
 *
 * This idiom was written inline at seven call sites (weapon qualities, NPC
 * traits, bestiary weapon ids, armour specials). Five of them filtered empty
 * entries and two did not, so a trailing comma or a double comma produced a
 * stray `''` in those two lists. Filtering is the correct behaviour for every
 * caller - an empty weapon quality or trait is meaningless - so this helper
 * always filters.
 *
 * Accepts `string | string[] | undefined` because items.json stores weapon
 * qualities in both shapes: 478 entries use an array and 268 a comma-separated
 * string. Passing an array through returns a trimmed copy, which lets callers
 * drop their own `Array.isArray` branch.
 */
export function parseCommaSeparated(input?: string | string[] | null): string[] {
  if (!input) return [];
  const parts = Array.isArray(input) ? input : input.split(',');
  return parts.map((part) => part.trim()).filter(Boolean);
}
